import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, IntegerDecoder } from "@simonbackx/simple-encoding";
import { isSimpleError, isSimpleErrors, SimpleError, SimpleErrors } from "@simonbackx/simple-errors";
import { Product } from "./Product";
import { OrderType } from "./OrderType";
export class CartItem extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.amount = 1;
    }
    get unitPrice() {
        return this.product.prices.unitPrice;
    }
    get price() {
        return this.product.prices.unitPrice * this.amount;
    }
    get warranty() {
        return Math.round(this.product.prices.warranty * this.amount * 0.05);
    }
    get boxes() {
        return Math.ceil(this.amount / this.product.soldPer);
    }
    validate(products) {
        const product = products.find(p => p.id === this.product.id);
        if (!product) {
            throw new SimpleError({
                code: "product_not_available",
                message: "The product that you wanted to order is not available any longer",
                human: "Het product " + this.product.name + " dat je wou bestellen is niet (meer) beschikbaar",
                field: "product"
            });
        }
        this.product = product.patch({});
        // Validate amount
        if (this.amount % this.product.soldPer !== 0) {
            // Correctly round
            this.amount = Math.ceil(this.amount / this.product.soldPer) * this.product.soldPer;
        }
    }
    get amountSuffix() {
        if (this.amount == 1) {
            return this.product.amountSuffixSingular;
        }
        return this.product.amountSuffix;
    }
}
__decorate([
    field({ decoder: Product })
], CartItem.prototype, "product", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], CartItem.prototype, "amount", void 0);
export class Cart extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    get amount() {
        return this.items.reduce((c, i) => c + i.amount, 0);
    }
    /**
     * Subtotal
     */
    get price() {
        return this.items.reduce((c, i) => c + i.price, 0);
    }
    get warranty() {
        return this.items.reduce((c, i) => c + i.warranty, 0);
    }
    get kgSaved() {
        return Math.ceil((this.items.reduce((c, i) => c + i.product.savedPlasticWeight * i.amount, 0)) / 100 * 6) / 10;
    }
    get boxes() {
        return this.items.reduce((c, i) => c + i.boxes, 0);
    }
    /**
     * @return returns the delivery cost in cents
     * @param orderType
     */
    getDeliveryCost(orderType) {
        if (orderType === OrderType.PickUp) {
            return 0;
        }
        const numberOfPallets = Math.ceil(this.boxes / 20);
        const oneTimeCost = 2500;
        const costPerPallet = 5000;
        const multiplierDeliveryRetrieval = 2; //Every pallet is charged for delivery and retrieval
        return ((numberOfPallets * costPerPallet) + oneTimeCost) * multiplierDeliveryRetrieval;
    }
    addItem(item) {
        for (const i of this.items) {
            if (i.product.id === item.product.id) {
                i.amount += item.amount;
                return;
            }
        }
        this.items.push(item);
    }
    removeItem(item, index) {
        this.items.splice(index, 1);
    }
    validate(products) {
        const errors = new SimpleErrors();
        for (const item of this.items) {
            try {
                item.validate(products);
            }
            catch (e) {
                if (isSimpleError(e) || isSimpleErrors(e)) {
                    errors.addError(e);
                }
                else {
                    throw e;
                }
            }
        }
        errors.throwIfNotEmpty();
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(CartItem) })
], Cart.prototype, "items", void 0);
//# sourceMappingURL=Cart.js.map